import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendJob, BackendMutationIntegrationAssetsSearchArgs } from 'src/types/backend';

import { FRAGMENT_JOB } from '../job';

const MUTATION = gql`
  mutation IntegrationAssetsSearch(
    $filter: SearchObjectEnum!
    $dataSource: IntegrationDataSourceEnum!
    $searchTerm: String
    $customerId: ID!
    $workspaceId: ID!
  ) {
    integrationAssetsSearch(
      filter: $filter
      dataSource: $dataSource
      searchTerm: $searchTerm
      customerId: $customerId
      workspaceId: $workspaceId
    ) {
      ...Job
    }
  }
  ${FRAGMENT_JOB}
`;

type Variables = BackendMutationIntegrationAssetsSearchArgs;
type Result = BackendJob;

export const integrationAssetsSearch = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
